import { useSearchParams } from 'react-router-dom';

import { ButtonsSelect } from '@/components/Elements/ButtonSelect';

export const Toolbar = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const status = searchParams.get('status') ?? 'all';

	return (
		<ButtonsSelect
			value={status}
			onChange={(e) => {
				const nextParams = new URLSearchParams(searchParams);
				if (e) nextParams.set('status', e);
				else nextParams.delete('status');
				setSearchParams(nextParams, { replace: true });
			}}
			options={[
				{ name: 'all', value: 'all', hideIcon: true },
				{ name: 'accepted', value: 'accepted', accentColor: '#18C096' },
				{ name: 'declined', value: 'declined', accentColor: '#AD012D' },
				{ name: 'no response', value: 'no-response', accentColor: '#EA6200' },
			]}
		/>
	);
};
